import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Image } from 'react-native';
export var StatusCardImageSection = props => {
  var url = props.url,
    iconDimension = props.iconDimension;
  return _jsx(_Fragment, {
    children: !!url && _jsx(Image, {
      source: {
        uri: url,
        width: (iconDimension === null || iconDimension === void 0 ? void 0 : iconDimension.width) || 210,
        height: (iconDimension === null || iconDimension === void 0 ? void 0 : iconDimension.height) || 150
      },
      resizeMode: "contain"
    })
  });
};